(function(algolia) {
  'use strict';
  const render = algolia.externals.render;
  const html = algolia.externals.html;

  var algoliasearch = algolia.externals.algoliasearch;
  algolia.searchClient = algoliasearch(
          algolia.config.app_id,
          algolia.config.search_api_key
  );

  algolia.render = (template, container, data) => {
    return render(template(html, data), container);
  };

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      // .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(val) {
      return Number(val).toLocaleString();
    },
    displayPrice: function displayPrice(item, distinct) {
      if (distinct) {
        var min = item.variants_min_price;
        var max = item.variants_max_price;
        if (min !== max) {
          return  formatPrice(min) + ' - ' + formatPrice(max);
        }
      }
      return formatPrice(item.price);
    },
    displayStrikedPrice: function displayStrikedPrice(price, compare_at_price) {
      const comparing =
        Number(compare_at_price) && Number(compare_at_price) > Number(price);
    
      if (comparing) {
        const discount_percentage =
          ((compare_at_price - price) / compare_at_price) * 100;
    
        if (
          discount_percentage >= parseInt(`19`) &&
          discount_percentage <= parseInt(`100`)
        ) {
          return formatPrice(compare_at_price);
        }
      }
    },
    displayDiscount: function displayDiscount(price, compare_at_price, price_ratio) {
      const comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price);
      const discount_ratio = 1.0 - price_ratio;
      const discount_percent = Math.floor(discount_ratio * 100);
      const minDiscount = parseInt(`19`);
      const maxDiscount = parseInt(`100`);
      if (comparing && discount_percent >= minDiscount && discount_percent <= maxDiscount) {
        return `-${discount_percent}%`
      }
    },
    instantsearchLink: function instantsearchLink(hit) {
      // const addVariantId = !hit._distinct && hit.objectID !== hit.id;
      return (
        '/products/' +
        hit.handle
      );
    },
    fullTitle: function fullTitle(title, distinct, variant_title) {
      var res = title;
      if (
        !distinct &&
        variant_title &&
        variant_title !== 'Default Title' &&
        variant_title !== 'Default'
      ) {
        res += ' (' + variant_title + ')';
      }

      return res;
      // return escapeHtml(res);
    },
    variantTitleAddition: function variantTitleAddition(item, distinct) {
      var res = ' ';
      if (
        !distinct &&
        item.variant_title &&
        item.variant_title !== 'Default Title' &&
        item.variant_title !== 'Default'
      ) {
        res += `( ${item.variant_title} )`;
      }
      return res;
    },
    hexToRGB: function hexToRGB(hex){
      if (!hex) return ``;
      if(hex.length== 4){
        hex = hex.substring(1).replace(/./g, '$&$&')
      }
      var m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
      return `${parseInt(m[1], 16)},${parseInt(m[2], 16)},${parseInt(m[3], 16)}`;
    },
    sizedImage: function sizedImage(sizeInput, item, _distinct) {
      var image = _distinct ? item.product_image : item.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = sizeInput.replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
    checkLinkedProducts: function checkLinkedProducts(hit) {
      let swatches = [];
      let defaultSwatchValue = "";
      if (hit.meta.linked_products) {
        try {
          let specifications;
          let linked_products = hit.meta.linked_products.handles;
          if(typeof linked_products == "string"){
            linked_products = JSON.parse(linked_products);
          } else{
            linked_products = linked_products;
          }
          linked_products.forEach(function(linked_product) {
            if (linked_product.color) {
              // console.log(linked_product);
              swatches.push(linked_product);
              if (hit.meta.product.specifications) {
                if(typeof hit.meta.product.specifications == "string"){
                  specifications = JSON.parse(hit.meta.product.specifications);
                } else{
                   specifications = hit.meta.product.specifications;
                }
                specifications.groups.forEach(function(group) {
                  if (group.name == "Kleuren") {
                    // console.log(group);
                    group.specs.forEach(function(spec) {
                      if (spec.name == "Kleur") {
                        if (spec.value == linked_product.color) {
                          defaultSwatchValue = spec.value;
                        }
                      }
                    });
                  }
                });
              }
            }

          });
        } catch (error) {
          console.error("Error parsing linked_products:", hit.meta.linked_products.handles);
        }
      }
      return [swatches, defaultSwatchValue];
    },
    quickDeliveryMessage: function quickDeliveryMessage(deliveryDays) {
      try {
        if (deliveryDays) {
          let jsonToParse = deliveryDays.trim();
          if (!jsonToParse.startsWith('{')) {
            jsonToParse = '{' + jsonToParse;
          }
          const deliveryDaysParsed = JSON.parse(jsonToParse);

          if (!deliveryDaysParsed.delivery_days) {
            return null;
          }

          const minDays = deliveryDaysParsed.delivery_days[0].min_days;
          const maxDays = deliveryDaysParsed.delivery_days[1].max_days;

          let minWeeks = Math.ceil(minDays / 5);
          let maxWeeks = Math.ceil(maxDays / 5);
          
          if (minWeeks === maxWeeks) {
            maxWeeks = minWeeks + 1;
          }
          
          if (minDays <= 7) {
            return `${window.quickDelivery.quickDeliveryDays
              .replace("|minDays|", minDays)
              .replace("|maxDays|", maxDays)}`; // X-Y days in house
          } else if (minDays <= 14) {
            // Express delivery time in weeks
            if (maxWeeks <= 2) {
              return `${window.quickDelivery.quickDeliveryWeeks
                .replace("|minWeeks|", minWeeks)
                .replace("|maxWeeks|", "")
                .replace(" - ", "")}`; // X-Y weeks in house
            } else {
              // Return a different message or null if maxWeeks is greater than 2
              return null;
            }
          } else {
            // Do not show label for delivery times longer than 2 weeks
            return null;
          }
        }
      }
      catch (error) {
        // Handle parsing error
        console.log("Error parsing delivery_days:", deliveryDays);
        return null;
      }
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original'
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = function(item) {
        var image = item.distinct ? item.product_image : item.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_800x600.$2');
    };
  });
})(window.algoliaShopify);
